import { MenuItemLink, MenuItemLinkProps } from 'react-admin';
import { useHasAccess } from '../../payWall/RevenueCatProvider';
import { MembershipType } from '../../payWall/paywall.model';
import { PaidFeatureIcon } from '../../components/pay-wall/PaidFeatureIcon';


type AppBarMenuItemAccessLinkProps = { membership: MembershipType } & MenuItemLinkProps;

export const AppBarMenuItemAccessLink = (props: AppBarMenuItemAccessLinkProps) => {
  const [hasAccess] = useHasAccess(props.membership);

  return (
    <MenuItemLink
      {...props}
      to={hasAccess ? props.to : '/pricing'}
      dense={false}
      {...(!hasAccess && { leftIcon: <PaidFeatureIcon membership={props.membership} /> })}
      state={{ _scrollToTop: true, ...(props.state || {}) }}
      tooltipProps={{ disableInteractive: true, children: <></>, title: '' }} // Disable tooltip
    />
  );
}
